import { InjectionToken } from '@angular/core';
export const FEATURE_NAME = '@zerops/zerops/terminal';
export const API_URL = new InjectionToken<string>('zerops-terminal/api-url');
export const FORCE_SECURED_ENDPOINT = new InjectionToken<string>('zerops-terminal/force-secured-endpoint');
